import { render } from "./Pagetitle.vue?vue&type=template&id=302454b8"
import script from "./Pagetitle.vue?vue&type=script&lang=js"
export * from "./Pagetitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__